export default "__VITE_ASSET__DGNLqKjz__"